import {
  SellerRatingSubmissionConfig as ISellerRatingConfig
} from 'services/api-service'

export class SellerRatingConfig implements ISellerRatingConfig {
  constructor(config: ISellerRatingConfig) {
    this.textMinLength = config.textMinLength
    this.textMaxLength = config.textMaxLength
  }

  textMinLength: number
  textMaxLength: number
}

let defaultConfig: ISellerRatingConfig = {}
export function loadConfig(config: ISellerRatingConfig): void {
  defaultConfig = new SellerRatingConfig(config)
}
export { defaultConfig as default }
